import React from 'react'
import {NavLink} from 'react-router-dom'


const ConditionalLink = ({to, valid, children}) => (
  valid ? 
    <NavLink 
      to={to}
      exact
      activeClassName="navigation-link__current"
    >{children}</NavLink> :
    <div className="navigation-link__disabled">{children}</div>
)

export default ConditionalLink


// WEBPACK FOOTER //
// ./src/onboarding/nav/views/conditional-link.jsx